export const beerDispenser = {
	title: "Dispensador de cerveza",
	searchPlaceholder: "Buscar",
	newBeerDispenser: "Nuevo dispensador",
	emptyText: "Ningún dispensador encontrado.",
	product: "Producto",
	ip: "IP",
	number: "N° del grifo",
	error: {
		requiredField: "Campo obligatorio",
		invalidIp: "Formato de IP inválido",
	},
	modal: {
		addBeerDispenser: "Agregar dispensador",
		editBeerDispenser: "Editar dispensador",
		name: "Nombre",
		product: "Producto",
		productTooltip: "Solo productos en mililitros/litros",
		number: "Número",
		dispenserIp: "IP del dispensador",
		deleteDispenser: "Eliminar dispensador",
		deleteText: "¿Está seguro que desea eliminar el dispensador <b>{{chopName}}</b>?",
	},
};
